import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { ArrowDownCircle, ArrowUpCircle } from 'lucide-react'
import './_appointment-card.scss'
import { Formatter } from 'shared-libs/helpers/formatter'
import apis from 'browser/app/models/apis'
import { Entity } from 'shared-libs/models/entity'
import classNames from 'classnames'

export const AppointmentCard: React.FC<any> = (props: any) => {
  const { value, onClick } = props
  const [appointment, setAppointment] = useState(value instanceof Entity ? value : null)

  useEffect(() => {
    if (!_.isEmpty(appointment)) {
      return
    }
    const fetchAppointment = async () => {
      const entityId = _.get(value, 'entityId', value)
      const record = await apis.getStore().getOrFetchRecord(entityId)
      setAppointment(record)
    }

    fetchAppointment()
  }, [appointment, value])

  const appointmentType = appointment?.get('core_yms_carrierAppointment.type')
  const isOutbound = appointmentType === 'Outbound'

  const IconComponent = isOutbound ? ArrowUpCircle : ArrowDownCircle
  const appointmentTypeClassName = classNames(
    'kiosk-appointment-card__type',
    {
      outbound: isOutbound,
      inbound: !isOutbound,
    }
  )
  const poNumber = _.first(
    appointment?.get?.('core_yms_carrierAppointment.purchaseOrderNumbers', [])
  )
  const appointmentName = appointment?.get('core_calendar_appointment.name')
  const shipmentNumber = appointment?.get('core_yms_carrierAppointment.shipmentNumber')
  const carrierName = appointment?.get('core_yms_carrierAppointment.carrier.displayName')
  const timeStart = Formatter.formatDateTime(
    appointment?.get('core_calendar_appointment.timeWindow.start.dateTime')
  )
  const loadType = appointment?.get('core_yms_carrierAppointment.loadType')

  const renderDetailItem = (label, value) => {
    return (
      <div>
        <label>{label}</label>
        <span>{value}</span>
      </div>
    )
  }

  if (_.isEmpty(value)) {
    return null
  }

  return (
    <div className="kiosk-appointment-card" onClick={onClick}>
      <header className="kiosk-appointment-card__header">
        <h3 className="kiosk-appointment-card__name">{appointmentName}</h3>
        {!_.isEmpty(appointmentType) && (
          <span className={appointmentTypeClassName}>
            <IconComponent size={16} strokeWidth={2.5} />
            {_.join([appointmentType, loadType], ' : ')}
          </span>
        )}
      </header>

      <div className="kiosk-appointment-card__body">
        {renderDetailItem('PO Number', poNumber)}
        {renderDetailItem('Shipment Number', shipmentNumber)}
        {renderDetailItem('Carrier', carrierName)}
        {renderDetailItem('Appointment Start', timeStart)}
      </div>
    </div>
  )
}
